<template>
  <div class="flex">
    <svg-icon type="mdi" :path="path"></svg-icon>
  </div>
</template>

<script>
import SvgIcon from '@jamescoyle/vue-icon';
import { mdiArrowBottomRight } from "@mdi/js"

export default {
  name: "ArrowBottomRightIcon",
  components: {
    SvgIcon
  },
  data() {
    return {
      path: mdiArrowBottomRight,
    }
  }
}
</script>
